module.exports = __webpack_public_path__ + "img/tab-discover-inactive.9c24cdb.png";